(() => {
  const money = (cents,currency) => new Intl.NumberFormat('en-US',{style:'currency',currency:currency || window.Shopify?.currency?.active || 'USD'}).format(cents/100);
  const update = cart => {
    const amount=money(cart.total_price,cart.currency);
    document.querySelectorAll('[data-mc-cart-total]').forEach(button=>{
      button.textContent=`${button.dataset.mcCheckoutLabel} · ${amount}`;
      button.disabled=cart.item_count===0;
    });
    document.querySelectorAll('[data-mc-order-total]').forEach(el=>{el.textContent=amount;el.dataset.mcTotalCents=String(cart.total_price);});
  };
  window.mcCartTotals={money,update};
})();
